module.exports = __webpack_public_path__ + "img/gallery_img_03_s.9eeaf5cf.jpg";